import {defineMessage} from 'react-intl'

export const PRODUCT_FEATURES1 = defineMessage({
    id: 'product_features_1',
    defaultMessage: 'Water and dirt resistant'
})

export const PRODUCT_FEATURES2 = defineMessage({
    id: 'product_features_2',
    defaultMessage: 'Can be used with or without horseshoe'
})

export const PRODUCT_FEATURES3 = defineMessage({
    id: 'product_features_3',
    defaultMessage: 'Up to 20 measurements battery life'
})

export const PRODUCT_FEATURES4 = defineMessage({
    id: 'product_features_4',
    defaultMessage: 'Different sizes can be combined'
})
